<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>AI Config - Chat Settings</h1>

        <!-- Success/Error Messages -->
        @if (successMessage) {
<div class="alert alert-success">
          <mat-icon>check_circle</mat-icon>
          {{ successMessage }}
        </div>
}

        @if (error) {
<div class="alert alert-danger">
          <mat-icon>error_outline</mat-icon>
          {{ error }}
        </div>
}

        @if (loading) {
      <app-ai-chat-settings-skeleton></app-ai-chat-settings-skeleton>
      }

        @if (!loading) {

          <p class="text-muted">Configure token budgets and behavior for the AI Chat feature</p>

          <!-- Current Settings View -->
          @if (chatSettings && !editingChatSettings) {
<div class="card" style="margin-bottom: 20px;">
            <div class="card-body">
              <h5>Current Chat Settings</h5>
              <table class="table">
                <tbody>
                  <tr>
                    <th style="width: 250px;">Connection:</th>
                    <td>{{ chatSettings.connection.name }}</td>
                  </tr>
                  <tr>
                    <th>Max Context Window:</th>
                    <td>{{ chatSettings.maxContextWindowTokens | number }} tokens</td>
                  </tr>
                  <tr>
                    <th>CMDB Token Budget:</th>
                    <td>{{ chatSettings.cmdbTokenBudget | number }} tokens</td>
                  </tr>
                  <tr>
                    <th>History Token Budget:</th>
                    <td>{{ chatSettings.historyTokenBudget | number }} tokens</td>
                  </tr>
                  <tr>
                    <th>Summary Token Budget:</th>
                    <td>{{ chatSettings.summaryTokenBudget | number }} tokens</td>
                  </tr>
                  <tr>
                    <th>Status:</th>
                    <td><span class="badge bg-success">Active</span></td>
                  </tr>
                </tbody>
              </table>

              <button type="button" class="btn btn-primary no-arrow" (click)="startEdit()">
                Edit Settings
              </button>
            </div>
          </div>
}

          <!-- No Settings Warning -->
          @if (!chatSettings && !editingChatSettings) {
<div class="alert alert-warning">
            No chat settings configured. Click "Configure" to set up AI Chat.
            <br>
            <button type="button" class="btn btn-primary no-arrow" (click)="startEdit()"
                    [disabled]="connections.length === 0" style="margin-top: 10px;">
              Configure Chat Settings
            </button>
            @if (connections.length === 0) {
<p class="text-danger" style="margin-top: 10px;">
              Please create at least one connection first.
            </p>
}
          </div>
}

          <!-- Edit Form -->
          @if (editingChatSettings) {
<div class="card" style="margin-bottom: 20px;">
            <div class="card-body">
              <h5>Configure AI Chat Settings</h5>

              <div class="form-group">
                <label>Connection <span class="text-danger">*</span></label>
                <select class="form-control" [(ngModel)]="editingChatSettings.aiConnectionId" [ngModelOptions]="{standalone: true}">
                  <option [value]="0">-- Select Connection --</option>
                  @for (conn of connections; track conn) {
<option [value]="conn.id">{{ conn.name }}</option>
}
                </select>
              </div>

              <div class="form-group">
                <label>Max Context Window Tokens</label>
                <input type="number" class="form-control" [(ngModel)]="editingChatSettings.maxContextWindowTokens"
                       [ngModelOptions]="{standalone: true}">
                <small class="text-muted">Maximum context window size (e.g., 400000 for GPT-5.2)</small>
              </div>

              <div class="form-group">
                <label>CMDB Token Budget</label>
                <input type="number" class="form-control" [(ngModel)]="editingChatSettings.cmdbTokenBudget"
                       [ngModelOptions]="{standalone: true}">
                <small class="text-muted">Token budget allocated for CMDB data context</small>
              </div>

              <div class="form-group">
                <label>History Token Budget</label>
                <input type="number" class="form-control" [(ngModel)]="editingChatSettings.historyTokenBudget"
                       [ngModelOptions]="{standalone: true}">
                <small class="text-muted">Token budget for conversation history</small>
              </div>

              <div class="form-group">
                <label>Summary Token Budget</label>
                <input type="number" class="form-control" [(ngModel)]="editingChatSettings.summaryTokenBudget"
                       [ngModelOptions]="{standalone: true}">
                <small class="text-muted">Token budget for conversation summaries</small>
              </div>

              <div class="form-group">
                <label>System Prompt <span class="text-danger">*</span></label>
                <textarea class="form-control" rows="5" [(ngModel)]="editingChatSettings.systemPrompt"
                          [ngModelOptions]="{standalone: true}"
                          placeholder="Define the AI's behavior and personality..."></textarea>
              </div>

              <div style="display: flex; justify-content: space-between;">
                <button type="button" class="btn btn-primary no-arrow"
                        (click)="save()" [disabled]="saving">
                  @if (saving) {
<mat-spinner diameter="20" style="display: inline-block; margin-right: 5px;"></mat-spinner>
}
                  {{ saving ? 'Saving...' : 'Save Settings' }}
                </button>
                <button type="button" class="btn btn-secondary no-arrow"
                        (click)="cancelEdit()" [disabled]="saving">
                  Cancel
                </button>
              </div>
            </div>
          </div>
}
        
}

      </div>
    </div>
  </section>
</main>
